/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Me_A_CodeInputs */

const th_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่งรหัสทางอีเมล`)
};

const en_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email me a code`)
};

const ja_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードをメールで送る`)
};

const zh_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`给我发送验证码`)
};

const es_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviarme un código`)
};

const pt_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar um código por e-mail`)
};

const id_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirimi saya kode`)
};

const fr_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M’envoyer un code`)
};

const tl_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padalhan ako ng code`)
};

const vi_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi mã cho tôi`)
};

const ko_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코드 보내주세요`)
};

const de_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code per E-Mail schicken`)
};

const ru_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прислать мне код`)
};

const tr_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bana kod gönder`)
};

const it_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviami un codice`)
};

const pl_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślij mi kod`)
};

const uk_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Надіслати мені код`)
};

const hi_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुझे कोड भेजें`)
};

const ar_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أرسل لي رمزًا`)
};

const ms_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantar kod kepada saya`)
};

const bn_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আমাকে কোড পাঠান`)
};

const zh_tw2_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寄驗證碼給我`)
};

const zh_hk2_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寄驗證碼給我`)
};

const ur_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجھے کوڈ بھیجیں`)
};

const fa_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کد را برایم بفرست`)
};

const sw_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nitumie msimbo`)
};

const nl_email_me_a_code = /** @type {(inputs: Email_Me_A_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stuur me een code`)
};

/**
* | output |
* | --- |
* | "Email me a code" |
*
* @param {Email_Me_A_CodeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_me_a_code = /** @type {((inputs?: Email_Me_A_CodeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Me_A_CodeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_me_a_code(inputs)
	if (locale === "ja") return ja_email_me_a_code(inputs)
	if (locale === "zh") return zh_email_me_a_code(inputs)
	if (locale === "es") return es_email_me_a_code(inputs)
	if (locale === "pt") return pt_email_me_a_code(inputs)
	if (locale === "id") return id_email_me_a_code(inputs)
	if (locale === "fr") return fr_email_me_a_code(inputs)
	if (locale === "tl") return tl_email_me_a_code(inputs)
	if (locale === "vi") return vi_email_me_a_code(inputs)
	if (locale === "ko") return ko_email_me_a_code(inputs)
	if (locale === "de") return de_email_me_a_code(inputs)
	if (locale === "ru") return ru_email_me_a_code(inputs)
	if (locale === "tr") return tr_email_me_a_code(inputs)
	if (locale === "it") return it_email_me_a_code(inputs)
	if (locale === "pl") return pl_email_me_a_code(inputs)
	if (locale === "uk") return uk_email_me_a_code(inputs)
	if (locale === "hi") return hi_email_me_a_code(inputs)
	if (locale === "ar") return ar_email_me_a_code(inputs)
	if (locale === "ms") return ms_email_me_a_code(inputs)
	if (locale === "bn") return bn_email_me_a_code(inputs)
	if (locale === "zh-TW") return zh_tw2_email_me_a_code(inputs)
	if (locale === "zh-HK") return zh_hk2_email_me_a_code(inputs)
	if (locale === "ur") return ur_email_me_a_code(inputs)
	if (locale === "fa") return fa_email_me_a_code(inputs)
	if (locale === "sw") return sw_email_me_a_code(inputs)
	if (locale === "nl") return nl_email_me_a_code(inputs)
	return en_email_me_a_code(inputs)
});